import { useState } from 'react';

import { Button, Input, Form } from 'antd';
import moment from 'moment';

import { ErrorResponse } from 'utils/types';
import notifier from 'utils/notifier';

import FloatLabel from 'components/Common/FloatLabel';
import DatePickerLocalised from 'components/Common/DatePickerLocalised';

import './index.scss';

interface SubmittedClaimsFormProps {
  isFetchingSubmitted: boolean,
  getSubmitted(searchObject: Object): any, //={props.getSubmitted}
  setDataSource(data: any[]): void,//={setSubmittedClaims}
};

const SubmittedClaimsForm = (props: SubmittedClaimsFormProps) => {

  const ALL_PROVIDERS = '{"Provider": "ALL PROVIDERS","RmiProvKeyId": null,"RmiCompanyId": null}';

  const [form] = Form.useForm();
  const [receivedDateFrom, setReceivedDateFrom] = useState('');
  const [receivedDateTo, setReceivedDateTo] = useState('');

  const DEFAULT_SEARCH_VALUES = {
    SubmittedDate: null,
    StatusValue: '',
    UserId: sessionStorage.getItem('user_id'),
  };

  const validationRules = async (fieldData: any, value: any) => {

    const charLessThanFive = (value: any) => fieldData.field === 'memberId' && value && value.trim().length < 5;

    if (charLessThanFive(value)) {
      return Promise.reject('Please enter at least 5 characters.');
    }
  };

  const onSearch = () => {
    form.validateFields().then(values => {
      let formData = {
        ClaimNo: values.claimRef !== '' ? values.claimRef : null,
        MemberId: values.memberId,
        ReceivedDateFrom: receivedDateFrom ? receivedDateFrom : null,
        ReceivedDateTo: receivedDateTo ? receivedDateTo : null,
        UserId: sessionStorage.getItem('user_id'),
      };

      return props.getSubmitted(formData)
        .then((response: any) => {
          if (response.length === 0) notifier.error('There were no results for this search. Please check the fields and try again.');
          props.setDataSource(response);
        })
        .catch((err: ErrorResponse) => {
          notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
        });
    })
  };

  const onReset = () => {
    props.setDataSource([]);
    form.resetFields();
    setReceivedDateFrom("");
    setReceivedDateTo("");
  };

  return (
    <Form
      form={form}
      name={'claimSearchForm'}
      onFinish={onSearch}
    >
        <div className="member-search row flex-lg-wrap justify-content-start mb-3 ml-0">

        <div className="col-lg-6">
          <FloatLabel
            label="Claim#/Claim Ref:"
            name="claimRef"
            form={form}
          >
            <Input />
          </FloatLabel>
        </div>

        <div className="col-lg-6">
          <FloatLabel
            label="Member ID:"
            name={'memberId'}
            form={form}
            rules={[
              { validator: validationRules }
            ]}
          >
            <Input />
          </FloatLabel>
        </div>

        <div className="col-lg-6">
          <FloatLabel
            label="Received From (MM/DD/YYYY)"
            name={'receivedDateFrom'}
            value={receivedDateFrom}
            form={form}
            rules={[
              () => ({
                async validator(_: any, __: any) {
                  const invalidDate = () => receivedDateFrom && (!moment(receivedDateFrom).isValid() || moment(receivedDateFrom).year() < 1900|| !receivedDateFrom.match(/^\d{2}\/\d{2}\/\d{4}$/));

                  if (invalidDate()) {
                    return Promise.reject(new Error('Invalid Date'));
                  }

                  return Promise.resolve();
                },
              })
            ]}
          >
          <DatePickerLocalised
            date={receivedDateFrom}
            setDate={setReceivedDateFrom}
          />
          </FloatLabel>
        </div>

        <div className="col-lg-6">
          <FloatLabel
            label="Received To (MM/DD/YYYY)"
            name={'receivedDateTo'}
            value={receivedDateTo}
            form={form}
            rules={[
              () => ({
                async validator(_: any, __: any) {
                  const invalidDate = () => receivedDateTo && (!moment(receivedDateTo).isValid() || moment(receivedDateTo).year() < 1900 || !receivedDateTo.match(/^\d{2}\/\d{2}\/\d{4}$/));

                  if (invalidDate()) {
                    return Promise.reject(new Error('Invalid Date'));
                  }

                  return Promise.resolve();
                },
              })
            ]}
          >
          <DatePickerLocalised
            date={receivedDateTo}
            setDate={setReceivedDateTo}
          />
          </FloatLabel>
        </div>
        <div className="col-lg-6 mt-2"></div>
        <div className="col-lg-6 mt-2"></div>
        <div className="col-lg-6 mt-2"></div>
        <div className="col-lg-6 mt-2">
          <Form.Item>
            <div className="d-flex justify-content-end">
              <Button type="primary" style={{ width: "50%" }} htmlType={'submit'} loading={props.isFetchingSubmitted}>SEARCH</Button>
              <Button type="default" style={{ width: "50%" }} onClick={onReset}>RESET</Button>
            </div>
          </Form.Item>
        </div>
    </div>
    </Form>
  );
}

export default SubmittedClaimsForm;